import React, { useState } from 'react';
import { Card, Select } from 'antd';
import { defaultOrderBy, defaultOrderDir } from './settings';
import ReportCardTitle from '../components/shared/ReportCardTitle/ReportCardTitle';
import TopKeywordsOverview from './TopKeywordsOverview';
import TopKeywordsResults from './TopKeywordsResults';
import ChangeLocationAndLanguage from '../trackedKeywords/ChangeLocationAndLanguage';
import useGetCurrentWebsite from '../deepAnalysis/websiteIndexEntry/hooks/useGetCurrentWebsite';


const { Option } = Select;


export default function TopKeywords() {
    const [state, setState] = useState({ orderBy: defaultOrderBy, orderDir: defaultOrderDir });
    const { website: selectedWebsite } = useGetCurrentWebsite();
    const websiteGuid = selectedWebsite?.guid || '';
    const domain = selectedWebsite?.domain || '';
    const locationName = selectedWebsite?.settings.location_name || 'United States';
    const languageCode = selectedWebsite?.settings.language_code || 'en';

    const handleOrderChange = (newOrder: string) => {
        const [newOrderBy, newOrderDir] = newOrder.split('_');
        setState({ orderBy: newOrderBy, orderDir: newOrderDir });
    };

    if (!selectedWebsite) {
        return null;
    }

    return (
        <>
            <TopKeywordsOverview
                key={`${websiteGuid}_${locationName}_${languageCode}`}
                domain={domain}
                locationName={locationName}
                languageCode={languageCode}
            />

            <Card
                className="keywords-data-overview"
                title={<ReportCardTitle title="Top Keywords" domain={domain} />}
                extra={
                    <div className="keywords-options card-actions">
                        <div className="sort-by">
                            <Select
                                defaultValue={`${state.orderBy}_${state.orderDir}`}
                                onChange={handleOrderChange}
                                value={`${state.orderBy}_${state.orderDir}`}
                            >
                                <Option value={'traffic_desc'}>High traffic</Option>
                                <Option value={'position_asc'}>High position</Option>
                                <Option value={'traffic_asc'}>Low traffic</Option>
                                <Option value={'position_desc'}>Low position</Option>
                            </Select>
                        </div>
                        <ChangeLocationAndLanguage websiteGuid={websiteGuid} domain={domain} locationName={locationName} languageCode={languageCode} />
                    </div>
                }
            >
                <TopKeywordsResults
                    key={`${websiteGuid}_${locationName}_${languageCode}_${state.orderBy}_${state.orderDir}`}
                    domain={domain}
                    locationName={locationName}
                    languageCode={languageCode}
                    orderBy={state.orderBy}
                    orderDir={state.orderDir}
                />
            </Card>
        </>
    );
}
